module.exports = __webpack_public_path__ + "assets/img/profile-connections-active-old.d78a2746.svg";